exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.copy-trigger-disabled__loader.loader-wrapper{width:auto\n}\n.copy-trigger-disabled__loader #loader{padding:0\n}\n.copy-trigger-disabled__loader .md-spinner-path{stroke:#fff\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/shared-components/mediaItem/CopyVideoUrlMenu.vue
// module id = 190
// module chunks = 0